import { InvoiceStatus } from "../enums";

/** Show "Collected By" only when payment has a collector id or populated collector user. */
export function paymentHasCollector(payment: unknown): boolean {
  if (!payment || typeof payment !== "object") {
    return false;
  }
  const p = payment as Record<string, unknown>;
  const id = typeof p.collectorId === "string" ? p.collectorId.trim() : "";
  if (id.length > 0) {
    return true;
  }
  const coll = p.collector;
  if (!Array.isArray(coll) || coll.length === 0) {
    return false;
  }
  return coll.some((entry) => {
    if (!entry || typeof entry !== "object") return false;
    const e = entry as Record<string, unknown>;
    const first = typeof e.firstName === "string" ? e.firstName.trim() : "";
    const last = typeof e.lastName === "string" ? e.lastName.trim() : "";
    return Boolean(first.length || last.length);
  });
}

export function formatInvoiceCollectorDisplay(
  payment:
    | { 
      collectorId?: string;
      collector?: Array<{ firstName?: string; lastName?: string }>;
    }
    | undefined,
): string {
  const c = payment?.collector?.find((entry) => {
    const first = typeof entry?.firstName === "string" ? entry.firstName.trim() : "";
    const last = typeof entry?.lastName === "string" ? entry.lastName.trim() : "";
    return first.length > 0 || last.length > 0;
  });
  const firstName = typeof c?.firstName === "string" ? c.firstName.trim() : "";
  const lastName = typeof c?.lastName === "string" ? c.lastName.trim() : "";
  const name = `${firstName} ${lastName}`.trim();
  if (name) return name;
  const collectorId = typeof payment?.collectorId === "string" ? payment.collectorId.trim() : "";
  return collectorId || "-";
}

export function isInvoiceTypeKnown(
  invoiceType: unknown,
): invoiceType is "ORDER" | "DELIVERY" {
  return invoiceType === "ORDER" || invoiceType === "DELIVERY";
}

export function getDeleteInvoiceDisabled(
  invoiceStatus: string | undefined,
  invoiceType?: unknown,
): boolean {
  if (!isInvoiceTypeKnown(invoiceType)) {
    return true;
  }
  const invoiceOk = invoiceStatus === InvoiceStatus.UNPAID;
  return !invoiceOk;
}

export function getDeleteInvoiceTooltip(
  invoiceStatus: string | undefined,
  invoiceType?: unknown,
): string {
  if (!isInvoiceTypeKnown(invoiceType)) {
    return "Cannot delete: invoice type is missing";
  }
  const invoiceTypeLabel = invoiceType.toLowerCase();
  if (invoiceStatus === InvoiceStatus.PAID) {
    return "Cannot delete: invoice is paid";
  }
  if (invoiceStatus === InvoiceStatus.RECEIVED) {
    return "Cannot delete: invoice is received";
  }
  if (invoiceStatus !== InvoiceStatus.UNPAID) {
    return "Cannot delete: only unpaid invoices can be removed";
  }
  return `Delete ${invoiceTypeLabel} invoice`;
}
